export default "__VITE_ASSET__b15ce784__"